import { Rest } from "utilities/rest";
import * as ActionCreator from "utilities/action.creator";
import { $processing, $done } from "services/activity/action";
import { $requesting, $success, $failure } from "services/form/action";

export const MODULE = "Shipment";
const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, "reset", () =>
  $reset.action()
);

export const $show = ActionCreator.Async(MODULE, "Get", (id) => {
  return async (dispatch) => {
    dispatch($processing($show.OPERATION));

    return await Rest.GET(`${API_URL}/public/shipment/${id}`)
      .then((response) => {
        dispatch($show.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($show.OPERATION)));
  };
});

export const $delivered = ActionCreator.Async(
  MODULE,
  "Delivered",
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/public/shipment/${id}/delivered`,
        payload
      )
        .then((response) => {
          dispatch($delivered.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $dispute = ActionCreator.Async(
  MODULE,
  "Dispute",
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/public/shipment/${id}/dispute`, payload)
        .then((response) => {
          dispatch($dispute.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $console = ActionCreator.Async(
  MODULE,
  "Console",
  (id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(`${API_URL}/public/shipment/${id}/console`, payload)
        .then((response) => {
          dispatch($console.success({ response: response }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);
